<template>
    <div class="modal fade in" style="display: block">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModalImage"> 
              <span aria-hidden="true">&times;</span></button>
          </div>
          <div class="modal-body">
            <slot></slot>
          </div>
        </div>
      </div>
    </div>
</template>

<script>

export default {

    methods: {
        closeModalImage() {
            this.$emit('closeModalImage')
        },

    }
}
</script>

<style lang="scss">
    .modal-header {
      padding: 0px !important;
      .close {
        font-size: 30px; 
        font-weight: 400;
        margin-right: 15px;
        margin-top: 0px;
      }
    }
    .modal-body {
      padding-top: 0px;
      max-height: 510px;

    }
    @media (min-width: 992px) {
      .modal-lg {
        width: 800px !important;
      }
    }

</style>


// WEBPACK FOOTER //
// src/components/layout/ModalImage.vue